@switch (typeButton) {
  @default{
    <button
      mat-raised-button
      [matButton]="matButtonAparence"
      [color]="color || null"
      [matTooltip]="tooltip"
      aria-label="Button that displays a tooltip when focused or hovered over"
      [routerLink]="href ? href : null"
      [disabled]="isDisabled"
      [type]="type"
      (submit)="submit($event)"
    >
    {{text}}
    </button>

  }
  @case('icon'){
    <button
        matIconButton
        [routerLink]="href ? href : null"
        [matTooltip]="tooltip"
    >
    <mat-icon>{{text}}</mat-icon>

    </button>
  }
}

